( function() {

	console.log("community");

	const communityLoadMore = document.querySelector('.js-community-load-more');

	if (communityLoadMore) {
	  communityLoadMore.addEventListener( 'click', () => {
	    console.log('load more');
	    // var button = $(this),
	    const communityQueryData = {
	      'action': 'loadmore',
	      'query': misha_loadmore_params.posts, // that's how we get params from wp_localize_script() function
	      'page' : misha_loadmore_params.current_page
	    };

	    const httpRequest = new XMLHttpRequest();

	    if (!httpRequest) {
	      alert('Giving up :( Cannot create an XMLHTTP instance');
	      return false;
	    }
	    httpRequest.onreadystatechange = alertContents;
	    httpRequest.open('POST', misha_loadmore_params.ajaxurl);
	    httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	    httpRequest.send(Object.keys(communityQueryData).map(key => key + '=' + communityQueryData[key]).join('&'));
	    communityLoadMore.disabled = true;



	    function alertContents() {
	      if (httpRequest.readyState === XMLHttpRequest.DONE) {
	        if (httpRequest.status === 200) {
	          const response = JSON.parse(httpRequest.responseText);
	          misha_loadmore_params.current_page++;
	          communityLoadMore.disabled = false;
	          if (misha_loadmore_params.current_page == misha_loadmore_params.max_page) {
	            communityLoadMore.remove();
	          };
	          
	          document.querySelector('.community-post-archive').innerHTML += response.posts;
	          // layout();
	        } else {
	          console.log('There was a problem with the request.');
	        }
	      }
	    }

	  });
	};
	

} )();